module.exports = __webpack_public_path__ + "img/image14@3x.06d9f10e.png";